import { VisibilityDeepWorkIcon, VisibilityPublicIcon } from "../../../../icons";
import { BlockVisibility, BlockVisibilityType } from "../../../../types/block/enum";
import VisibilityHiddenIcon from "../../../atom/icons/VisibilityHiddenIcon";

const VisibilityIcon = ({
  type,
  color,
  className,
}: {
  type: BlockVisibilityType;
  color?: string;
  className?: string;
}) => {
  if (type === BlockVisibility.PUBLIC) {
    return (
      <VisibilityPublicIcon
        color={color}
        className={className}
      />
    );
  }

  if (type === BlockVisibility.DEEPWORK) {
    return (
      <VisibilityDeepWorkIcon
        color={color}
        className={className}
      />
    );
  }

  if (type === BlockVisibility.INVISIBLE) {
    return (
      <VisibilityHiddenIcon
        color={color}
        className={className}
      />
    );
  }

  return null;
};

export default VisibilityIcon;
